import * as React from 'react'

// import * as classnames from 'classnames'
import * as styles from './nextChapterCover.css'

import { injectStores } from '../../../store'
import { observer } from 'mobx-react'
import { LesenButton } from '../../common/elements/buttons'
import { ScrollPageChild } from '../../common/scrollpage'
import { observable } from 'mobx'
import { ContentChapter } from '../storydocStoreContent'
// import { Raster } from '../../common/elements/raster'
import { bind } from 'bind-decorator'

// import posed from 'react-pose'
import { replaceFilename } from '../../../utils/StringUtils'
import { colorHexAlpha } from '../../../utils/Color'

const lesenButton = require('../../common/icons/read-chapter.svg')
const lesenButtonMobile = require('../../common/icons/mobile-read-chapter.svg')
const raster = require('../../common/icons/raster.svg')
const transpImg = require('../../common/video/transparent.png')

export interface INextChapterCover {
  data: ContentChapter
  nextData: ContentChapter
  active: boolean
}

@injectStores
@observer
export class NextChapterCover extends ScrollPageChild<INextChapterCover > {
  @observable scrollTop = 0

  element: HTMLDivElement | null = null
  titleElem: HTMLDivElement | null = null
  bottomElement: HTMLDivElement | null = null

  @bind
  handleClick () {
    this.store.storeRouter.push(`/story/${this.props.nextData.uid}`)
  }

  render () {
    // console.log('next cover props', this.props)
    // let titleWidth: string | number | undefined = undefined
    // if (this.titleElem) {
    //   if (this.titleElem.clientWidth < 0.7 * this.store.storeCommon.window.width) {
    //     titleWidth = '20ch'
    //   }
    // }

    let nextBackground: JSX.Element | null = null
    if (this.props.nextData) {
      if (this.props.nextData.idx > 0) {
        nextBackground = <div className={styles.introBgImage} style={{ backgroundImage: `url('${replaceFilename(this.props.nextData.urlIntroVideo, 'firstframe.jpg')}')` }}></div>
      } else {
        nextBackground = <div className={styles.introBgImage} style={{ backgroundImage: `url(${this.props.nextData.urlOptionalBgImage})` }}></div>
      }
    }

    let nextColorOverlay: JSX.Element | null = null
    const nextColor = this.props.nextData && this.props.nextData.idx < this.store.storyDocContent.chapters.length - 1 ? this.store.storyDocContent.chapters[this.props.nextData.idx + 1].color : '#000000'
    const color2 = colorHexAlpha(nextColor, 0.3)
    const color1 = colorHexAlpha(this.props.nextData && this.props.nextData.color, 0.3)

    nextColorOverlay = <div className={styles.nextColorOverlay} style={{
      backgroundImage: `linear-gradient(to right, ${color1} 70%, ${color2}), linear-gradient(rgba(0,0,0,0.2),rgba(0,0,0,0.2)), url(${raster}) `,
      height: this.store.breakpoints.desktop ? this.store.storeCommon.window.height : this.store.storeCommon.window.height * 0.8
    }}></div>

    let nextChapterNumber: JSX.Element | null = null
    if (this.props.nextData) {
      if (this.store.breakpoints.phone) {
        nextChapterNumber = null
      } else {
        nextChapterNumber = <div className={styles.nextChapterNumber} style={{ opacity: this.props.nextData.idx > 0 ? 1 : 0 }}>
          <img src={this.props.nextData ? this.props.nextData.icon : transpImg} alt='chapter_#' />
        </div>
      }
    }

    let kapitelText = this.store.storeCommon.menu.language === 'en' ? 'Chapter' : 'Kapitel'

    let textBox: JSX.Element | null = null
    if (this.props.nextData) {
      if (this.props.nextData.idx === 0) {
        textBox = <div className={styles.introTextBox}>
          <div className={styles.introTitle}>{this.props.nextData.title}</div>
        </div>
      } else {
        textBox = <div className={styles.textBox}>
          <div className={styles.kapitel}>{kapitelText} {this.props.nextData.idx}</div>
          <div className={styles.title} style={this.props.nextData.idx === 1 ? { hyphens: 'auto' } : undefined}>{this.props.nextData.title}</div>
        </div >
      }
    }

    let coverPart: JSX.Element | null = null
    if ((this.props.scrollPos || this.props.scrollPos === 0) && this.props.scrollPos >= 0 && !this.store.storeCommon.menu.showYellowProgress && this.props.active) {
      coverPart = <div
                // <Overlay
                //   pose={this.props.scrollPos && this.props.scrollPos > 0 ? 'open' : 'closed'}
                //   key='cover-overlay'
                  className={ styles.cover }
                  ref={ elem => this.element = elem }
                  style={{ height: this.store.breakpoints.desktop ? this.store.storeCommon.window.height : this.store.storeCommon.window.height * 0.8,
                    transform: this.store.breakpoints.desktop ? `translate3d(${ 100 * (1 - this.props.scrollPos) }%, 0, 0)` : 'none'}}
                >
                  { nextBackground }
                  <div className={ styles.contentBox }>
                    { nextColorOverlay }
                    <div
                      className={styles.numberAndText}
                      ref={elem => this.titleElem = elem}
                      style={this.props.nextData && this.props.nextData.idx > 0 ?
                        { left: this.store.storeCommon.window.width < 770 ? '0' : '13%' } :
                        { justifyContent: this.store.breakpoints.phone ? 'center' : undefined }}>
                      {nextChapterNumber}
                      {textBox}
                    </div>
                    <div className={styles.buttonsArea}>
                      <LesenButton className={styles.lesenButton} onClick={this.handleClick} language={this.store.storeCommon.menu.language}>
                        <img src={this.store.breakpoints.desktop ? lesenButton : lesenButtonMobile} />
                      </LesenButton>
                    </div>
                  </div>
                  <div className={styles.bottom} ref={elem => this.bottomElement = elem}></div>
                {/* </Overlay> */}
                </div>
    }

    // section part
    let chapterNumber: JSX.Element | null = null
    if (this.props.data && this.props.data.idx > 0) {
      chapterNumber = <div className={styles.chapterNumber}><img src={this.props.data ? this.props.data.icon : null} alt='chapter_#' /></div>
    }

    const color = colorHexAlpha(this.props.data && this.props.data.color, 0.3)
    let colorOverlay: JSX.Element | null = null
    colorOverlay = <div className={styles.colorOverlay} style={{ backgroundImage: `linear-gradient(${color}, ${color}), url(${raster})` }} ></div>

    let whiteOverlay: JSX.Element | null = null
    whiteOverlay = <div className={styles.whiteOverlay}></div>

    let backgroundImage
    if (this.props.data) {
      if (this.props.data.idx > 0) {
        backgroundImage = replaceFilename(this.props.data.urlIntroVideo, 'firstframe.jpg')
      } else {
        backgroundImage = this.props.nextData.urlOptionalBgImage
      }
    }

    if (this.props.nextData) {
      return (
        <div className={styles.section}>
          <div className={styles.contentHolder} style={{ backgroundImage: `url('${backgroundImage}')`, height: this.store.storeCommon.window.height }}>
            {colorOverlay}
            {whiteOverlay}
            {this.store.breakpoints.desktop && chapterNumber}
          </div>
         { this.store.breakpoints.desktop ? coverPart : coverPart}
        </div>
      )
    } else {
      return <div />
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/storydoc/book/nextChapterCover.tsx